import React from "react";
import { Button, Container, Typography, Box } from "@mui/material";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { useTranslation } from "react-i18next";

const StepNavigation = ({
  onBack,
  onContinue,
  backLabel = "بازگشت",
  continueLabel = "ادامه",
  showBack = true,
  showContinue = true,
  continueDisabled = false,
  backDisabled = false,
  continueType = "contained",
  continueColor = "primary",
  containerSx = {},
  continueIcon,
  backIcon,
  continueButtonSx = {},
  backButtonSx = {},
  justifyEndIfSingle = false,
}) => {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir() === "rtl";

  // Set icons based on direction if not provided
  const ContinueIcon = isRTL ? KeyboardArrowLeftIcon : KeyboardArrowRightIcon;
  const BackIcon = isRTL ? KeyboardArrowRightIcon : KeyboardArrowLeftIcon;

  // Determine justifyContent
  let justifyContent = "space-between";
  if (!showBack && showContinue && justifyEndIfSingle) {
    justifyContent = "flex-end";
  }

  return (
    <Container
      sx={{
        position: "fixed",
        left: 0,
        right: 0,
        bottom: { xs: '6.5rem', sm: '6.5rem' }, // Place above nav
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: "100vw",
        maxWidth: "100vw",
        px: 0,
        zIndex: 12,
        pointerEvents: "none", // allow only children to be clickable
        ...containerSx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          justifyContent,
          alignItems: "center",
          width: {
            xs: "95%",
            sm: "90%",
            md: "70%",
            xl: "50%",
          },
          py: { xs: 1, sm: 1.5 },
          px: { xs: 1, sm: 2 },
          pointerEvents: "auto", // make buttons clickable
        }}
      >
        {showBack && (
          <Button
            variant="outlined"
            color="primary"
            onClick={onBack}
            disabled={backDisabled}
            sx={{
              borderRadius: "100px",
              backgroundColor: "#fff",
              border: "2px solid",
              px: 2.5,
              py: 1.1,
              minWidth: 120,
              display: "flex",
              alignItems: "center",
              gap: 1,
              boxShadow: 1,
              ...backButtonSx,
            }}
          >
            {React.cloneElement(backIcon || <BackIcon />, { sx: { fontSize: 26 } })}
            <Typography sx={{ px: 1, fontWeight: 700, fontSize: 15 }}>
              {backLabel}
            </Typography>
          </Button>
        )}
        {showContinue && (
          <Button
            type="submit"
            variant={continueType}
            sx={{
              borderRadius: "100px",
              px: 2.5,
              py: 1.1,
              minWidth: 120,
              display: "flex",
              alignItems: "center",
              gap: 1,
              boxShadow: continueType === "contained" ? 2 : 0,
              ...continueButtonSx,
            }}
            color={continueColor}
            onClick={onContinue}
            disabled={continueDisabled}
          >
            <Typography sx={{ px: 1, fontSize: 15, fontWeight: 700 }}>
              {continueLabel}
            </Typography>
            {React.cloneElement(continueIcon || <ContinueIcon />, { sx: { fontSize: 26 } })}
          </Button>
        )}
      </Box>
    </Container>
  );
};

export default StepNavigation;
